import { Box } from '@/components/Box/Box';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { useLogout } from '@/bundle/shared/hooks/useLogout';

export const LogoutLink = () => {
  const { mutate } = useLogout();

  return (
    <Box margin='68px 0 24px' mobile={{ margin: '32px 0' }}>
      <NavigationLink to={''} onClick={() => mutate()}>
        {'< Return to Login'}
      </NavigationLink>
    </Box>
  );
};
